// extracted by mini-css-extract-plugin
export default {"moreBtnRight":"Validator_moreBtnRight__PLUOo","bgImg":"Validator_bgImg__1T+ua"};